import { serviceTypes } from "utils/Types";
import { HTTP_METHOD } from "./ServiceHelper";
import { BASE_ROUTES } from "./baseRoutes";

const USER_SERVICE = serviceTypes.user;
const LIBRARY_SERVICE = serviceTypes.library;
const USER_PLAN_SERVICE = serviceTypes.userplan;
const NOTIFICATION_SERVICE = serviceTypes.notification;
const RECOMMNDATION_SERVICE = serviceTypes.recommendation;
const GATEWAY_SERVICE = serviceTypes.gateWay;

export const USER_SERVICES_METHOD = {
  getAssociates: { method: HTTP_METHOD.GET, path: BASE_ROUTES.associates, serviceType: USER_SERVICE },
  getRoles: { method: HTTP_METHOD.GET, path: `roles`, serviceType: USER_SERVICE },
  postCorporatePermissions: { method: HTTP_METHOD.POST, path: "corporate/permissions", serviceType: USER_SERVICE },
  patchCorporatePermissions: {
    method: HTTP_METHOD.PATCH,
    path: "corporate/permissions",
    serviceType: USER_SERVICE
  },
  patchAssociatesMetadata: {
    method: HTTP_METHOD.PATCH,
    path: `${BASE_ROUTES.associates}/metadata`,
    serviceType: USER_SERVICE
  },
  patchAssociates: { method: HTTP_METHOD.PATCH, path: BASE_ROUTES.associates, serviceType: USER_SERVICE },
  postAssociatesRoles: { method: HTTP_METHOD.POST, path: `${BASE_ROUTES.associates}/roles`, serviceType: USER_SERVICE },
  postImpersonationAudits: { method: HTTP_METHOD.POST, path: BASE_ROUTES.impersonateAudits, serviceType: USER_SERVICE },
  getAssociatesMetadata: { method: HTTP_METHOD.GET, path: BASE_ROUTES.associatesMetaData, serviceType: USER_SERVICE }
};

export const LIBRARY_SERVICE_METHOD = {
  getBookmarks: { method: HTTP_METHOD.GET, path: BASE_ROUTES.bookmarks, serviceType: LIBRARY_SERVICE },
  postBookmarks: { method: HTTP_METHOD.POST, path: BASE_ROUTES.bookmarks, serviceType: LIBRARY_SERVICE },
  postDashboardPlans: { method: HTTP_METHOD.POST, path: BASE_ROUTES.plans, serviceType: LIBRARY_SERVICE },
  deleteBookmarks: { method: HTTP_METHOD.DELETE, path: BASE_ROUTES.bookmarks, serviceType: LIBRARY_SERVICE },
  postPlans: { method: HTTP_METHOD.POST, path: BASE_ROUTES.plans, serviceType: LIBRARY_SERVICE },
  getIndividualActionDetail: { method: HTTP_METHOD.GET, path: BASE_ROUTES.cards, serviceType: LIBRARY_SERVICE },
  postCards: { method: HTTP_METHOD.POST, path: BASE_ROUTES.cards, serviceType: LIBRARY_SERVICE },
  getPropertyInfo: { method: HTTP_METHOD.GET, path: BASE_ROUTES.propertyInfo, serviceType: LIBRARY_SERVICE },
  getInncode: { method: HTTP_METHOD.GET, path: BASE_ROUTES.innCodes, serviceType: LIBRARY_SERVICE },
  getManagementCompany: { method: HTTP_METHOD.GET, path: BASE_ROUTES.managementCompany, serviceType: LIBRARY_SERVICE },
  getOwnerGroups: { method: HTTP_METHOD.GET, path: BASE_ROUTES.ownerGroups, serviceType: LIBRARY_SERVICE },
  getPlans: { method: HTTP_METHOD.GET, path: BASE_ROUTES.plans, serviceType: LIBRARY_SERVICE },
  getFunctionalAreas: {
    method: HTTP_METHOD.GET,
    path: BASE_ROUTES.functionalAreas,
    serviceType: LIBRARY_SERVICE
  },
  getDisclaimerAndPrivacy: {
    method: HTTP_METHOD.GET,
    path: BASE_ROUTES.legal,
    serviceType: LIBRARY_SERVICE
  },
  postInncodeInfo: { method: HTTP_METHOD.POST, path: BASE_ROUTES.inncodeInfo, serviceType: LIBRARY_SERVICE },
  getSharedLink: { method: HTTP_METHOD.GET, path: BASE_ROUTES.sharedLink, serviceType: LIBRARY_SERVICE },
  postSharedLink: { method: HTTP_METHOD.POST, path: BASE_ROUTES.sharedLink, serviceType: LIBRARY_SERVICE }
};

export const USER_PLAN_SERVICE_METHOD = {
  getComments: { method: HTTP_METHOD.GET, path: `${BASE_ROUTES.comments}`, serviceType: USER_PLAN_SERVICE },
  postComments: { method: HTTP_METHOD.POST, path: `${BASE_ROUTES.comments}`, serviceType: USER_PLAN_SERVICE },
  getFeedbackForms: { method: HTTP_METHOD.GET, path: `${BASE_ROUTES.feedback}/forms`, serviceType: USER_PLAN_SERVICE },
  getFeedbackForm: { method: HTTP_METHOD.GET, path: `${BASE_ROUTES.feedback}/forms`, serviceType: USER_PLAN_SERVICE },
  getFeedbackFormsQuestionsCategories: {
    method: HTTP_METHOD.GET,
    path: `${BASE_ROUTES.feedback}/forms/questions/categories`,
    serviceType: USER_PLAN_SERVICE
  },
  putFeedbackForms: { method: HTTP_METHOD.PUT, path: `${BASE_ROUTES.feedback}/forms`, serviceType: USER_PLAN_SERVICE },
  postFeedback: { method: HTTP_METHOD.POST, path: BASE_ROUTES.feedback, serviceType: USER_PLAN_SERVICE },
  getBookmarkedInncodes: { method: HTTP_METHOD.GET, path: BASE_ROUTES.bookmarks, serviceType: USER_PLAN_SERVICE },
  getCardOverviewReport: {
    method: HTTP_METHOD.GET,
    path: `${BASE_ROUTES.plans}/reports/cards/overview`,
    serviceType: USER_PLAN_SERVICE
  },
  getDashboardReport: { method: HTTP_METHOD.GET, path: `${BASE_ROUTES.plans}/reports`, serviceType: USER_PLAN_SERVICE },
  getPlanOverviewReport: {
    method: HTTP_METHOD.GET,
    path: `${BASE_ROUTES.plans}/reports/plans/overview`,
    serviceType: USER_PLAN_SERVICE
  },
  getBookmarkedInncodeAsync: {
    method: HTTP_METHOD.GET,
    path: `${BASE_ROUTES.bookmarks}`,
    serviceType: USER_PLAN_SERVICE
  },
  putBookmarked: { method: HTTP_METHOD.PUT, path: `${BASE_ROUTES.bookmarks}`, serviceType: USER_PLAN_SERVICE },
  getInncodeGroups: { method: HTTP_METHOD.GET, path: BASE_ROUTES.inncodeGroups, serviceType: USER_PLAN_SERVICE },
  patchInncodeGroups: { method: HTTP_METHOD.PATCH, path: BASE_ROUTES.inncodeGroups, serviceType: USER_PLAN_SERVICE },
  getProgressTableInfo: { method: HTTP_METHOD.GET, path: BASE_ROUTES.inncodeGroups, serviceType: USER_PLAN_SERVICE },
  getFilterCategories: {
    method: HTTP_METHOD.GET,
    path: BASE_ROUTES.filterCategories,
    serviceType: USER_PLAN_SERVICE
  },
  getFilters: { method: HTTP_METHOD.GET, path: BASE_ROUTES.filters, serviceType: USER_PLAN_SERVICE },
  postFilters: { method: HTTP_METHOD.POST, path: BASE_ROUTES.filters, serviceType: USER_PLAN_SERVICE },
  putFilters: { method: HTTP_METHOD.PUT, path: BASE_ROUTES.filters, serviceType: USER_PLAN_SERVICE },
  patchInncodeGroup: {
    method: HTTP_METHOD.PATCH,
    path: BASE_ROUTES.inncodeGroups,
    serviceType: USER_PLAN_SERVICE
  },
  postDuplicateFilter: { method: HTTP_METHOD.POST, path: BASE_ROUTES.duplicateFilter, serviceType: USER_PLAN_SERVICE },
  deletePlans: { method: HTTP_METHOD.DELETE, path: BASE_ROUTES.plans, serviceType: USER_PLAN_SERVICE },
  getPlans: { method: HTTP_METHOD.GET, path: BASE_ROUTES.plans, serviceType: USER_PLAN_SERVICE },
  getInncodeGroup: { method: HTTP_METHOD.GET, path: BASE_ROUTES.inncodeGroups, serviceType: USER_PLAN_SERVICE },
  postInncodeGroup: { method: HTTP_METHOD.POST, path: BASE_ROUTES.inncodeGroups, serviceType: USER_PLAN_SERVICE },
  getRecentViews: { method: HTTP_METHOD.GET, path: BASE_ROUTES.recentViews, serviceType: USER_PLAN_SERVICE },
  getViewPlansOverview: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.viewPlansOverview,
    serviceType: USER_PLAN_SERVICE
  },
  postViewInncodeGroupSummary: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.viewInncodeGroupSummary,
    serviceType: USER_PLAN_SERVICE
  },
  postRecentViews: { method: HTTP_METHOD.POST, path: BASE_ROUTES.recentViews, serviceType: USER_PLAN_SERVICE },
  postViewPropertiesSummary: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.viewPropertiesSummary,
    serviceType: USER_PLAN_SERVICE
  },
  postViewPlansSummary: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.viewPlansSummary,
    serviceType: USER_PLAN_SERVICE
  },
  postPropertiesOverview: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.viewPropertiesOverview,
    serviceType: USER_PLAN_SERVICE
  },
  deleteInncodeGroups: {
    method: HTTP_METHOD.DELETE,
    path: BASE_ROUTES.inncodeGroups,
    serviceType: USER_PLAN_SERVICE
  },
  deleteFilters: {
    method: HTTP_METHOD.DELETE,
    path: BASE_ROUTES.filters,
    serviceType: USER_PLAN_SERVICE
  },
  patchPlans: { method: HTTP_METHOD.PATCH, path: BASE_ROUTES.plans, serviceType: USER_PLAN_SERVICE },
  putplans: { method: HTTP_METHOD.PUT, path: BASE_ROUTES.plans, serviceType: USER_PLAN_SERVICE },
  postPlans: { method: HTTP_METHOD.POST, path: BASE_ROUTES.plans, serviceType: USER_PLAN_SERVICE },
  getAboveProperty: { method: HTTP_METHOD.GET, path: BASE_ROUTES.aboveProperty, serviceType: USER_PLAN_SERVICE },
  postAboveProperty: { method: HTTP_METHOD.POST, path: BASE_ROUTES.aboveProperty, serviceType: USER_PLAN_SERVICE },
  getPagePreferences: { method: HTTP_METHOD.GET, path: BASE_ROUTES.pagePreferences, serviceType: USER_PLAN_SERVICE },
  putPagePreferences: { method: HTTP_METHOD.PUT, path: BASE_ROUTES.pagePreferences, serviceType: USER_PLAN_SERVICE },
  postAbovePropertyPropertiesPaged: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.abovePropertyPropertiesPaged,
    serviceType: USER_PLAN_SERVICE
  },
  putAboveProperty: {
    method: HTTP_METHOD.PUT,
    path: BASE_ROUTES.aboveProperty,
    serviceType: USER_PLAN_SERVICE
  },
  postPlanAssignment: { method: HTTP_METHOD.POST, path: BASE_ROUTES.planAssignment, serviceType: USER_PLAN_SERVICE },
  postPlanAssignmentPreview: {
    method: HTTP_METHOD.POST,
    path: `${BASE_ROUTES.planAssignment}/preview`,
    serviceType: USER_PLAN_SERVICE
  },
  postAbovePropertyMembers: {
    method: HTTP_METHOD.POST,
    path: `${BASE_ROUTES.aboveProperty}/members`,
    serviceType: USER_PLAN_SERVICE
  },
  postAbovePropertyMembersSnapshot: {
    method: HTTP_METHOD.POST,
    path: `${BASE_ROUTES.aboveProperty}/members/snapshot`,
    serviceType: USER_PLAN_SERVICE
  },
  postAbovePropertyPropertySnapshot: {
    method: HTTP_METHOD.POST,
    path: `${BASE_ROUTES.aboveProperty}/property/snapshot`,
    serviceType: USER_PLAN_SERVICE
  },
  postAbovePropertyPlans: {
    method: HTTP_METHOD.POST,
    path: `${BASE_ROUTES.aboveProperty}/plans`,
    serviceType: USER_PLAN_SERVICE
  },
  uploadImportList: {
    method: HTTP_METHOD.UPLOAD,
    path: BASE_ROUTES.importList,
    serviceType: USER_PLAN_SERVICE
  },
  getTeamMemberProgress: {
    method: HTTP_METHOD.GET,
    path: BASE_ROUTES.teamMembersProgress,
    serviceType: USER_PLAN_SERVICE
  }
};

export const NOTIFICATION_SERVICE_METHOD = {
  getNotifications: { method: HTTP_METHOD.GET, path: BASE_ROUTES.notifications, serviceType: NOTIFICATION_SERVICE },
  getNotificationResources: {
    method: HTTP_METHOD.GET,
    path: `${BASE_ROUTES.resources}`,
    serviceType: NOTIFICATION_SERVICE
  },
  putNotifications: { method: HTTP_METHOD.PUT, path: BASE_ROUTES.notifications, serviceType: NOTIFICATION_SERVICE },
  deleteNotifications: {
    method: HTTP_METHOD.DELETE,
    path: BASE_ROUTES.notifications,
    serviceType: NOTIFICATION_SERVICE
  },
  postUserVisit: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.userVisitPage,
    serviceType: NOTIFICATION_SERVICE
  }
};

export const RECOMMNDATION_SERVICE_METHOD = {
  getWizards: { method: HTTP_METHOD.GET, path: BASE_ROUTES.wizards, serviceType: RECOMMNDATION_SERVICE },
  getWizardsCheck: {
    method: HTTP_METHOD.GET,
    path: `${BASE_ROUTES.wizards}/ON_BOARDING/check`,
    serviceType: RECOMMNDATION_SERVICE
  },
  putWizardsResponse: {
    method: HTTP_METHOD.PUT,
    path: `${BASE_ROUTES.wizards}/response`,
    serviceType: RECOMMNDATION_SERVICE
  },
  putFeedbacks: { method: HTTP_METHOD.PUT, path: BASE_ROUTES.feedbacks, serviceType: RECOMMNDATION_SERVICE },

  putSuggestedPlans: {
    method: HTTP_METHOD.PUT,
    path: BASE_ROUTES.suggestedPlans,
    serviceType: RECOMMNDATION_SERVICE
  },
  postSuggestions: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.suggestions,
    serviceType: RECOMMNDATION_SERVICE
  },
  postSuggestedPlans: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.suggestedPlans,
    serviceType: RECOMMNDATION_SERVICE
  },
  deleteSuggestedPlans: {
    method: HTTP_METHOD.DELETE,
    path: BASE_ROUTES.suggestedPlans,
    serviceType: RECOMMNDATION_SERVICE
  },
  fileUpload: {
    method: HTTP_METHOD.UPLOAD,
    path: BASE_ROUTES.recommendations,
    serviceType: RECOMMNDATION_SERVICE
  },
  fileUploadMatrics: {
    method: HTTP_METHOD.UPLOAD,
    path: BASE_ROUTES.uploadMatrics,
    serviceType: RECOMMNDATION_SERVICE
  },
  getMetrics: {
    method: HTTP_METHOD.GET,
    path: BASE_ROUTES.metrics,
    serviceType: RECOMMNDATION_SERVICE
  }
};

export const GATEWAY_SERVICE_METHOD = {
  postErrorLog: {
    method: HTTP_METHOD.POST,
    path: BASE_ROUTES.errorLog,
    serviceType: GATEWAY_SERVICE
  }
};
